/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect } from 'react';
import TabelWorker from 'components/tabel/tabelWorker/TabelWorker';
import DashboardContext from 'Context';

export default function CanceledOrders() {
  const { handelFromTabel } = useContext(DashboardContext);

  useEffect(() => {
    handelFromTabel({
      userId: JSON.parse(sessionStorage.getItem('customerid')),
    });
  }, []);

  return (
    <TabelWorker
      urldata='/businessToBusinessCanceledOrder'
      isform hiddenitem
      itemname='userId'
    />
  );
}
